import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

export default {
  signUp(params) {
    return Api()
      .post("/api/presence/signup", params)
      .catch((err) => errorHandler(err, null));
  },
  getSignings(params) {
    return Api()
      .get("/api/presence/signing", { params })
      .catch((err) => errorHandler(err, null));
  },
  getWorkTime(params) {
    return Api()
      .get("/api/schedules", { params })
      .catch((err) => errorHandler(err, null));
  },
  getSigningsWithEmployee(params) {
    return Api()
      .get("/api/presence/report", { params })
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsUser(params) {
    return Api()
      .get("/api/work_records", { params })
      .catch((err) => errorHandler(err, null));
  },
  // TODO: Elminar
  postWorkRecordsUser(params) {
    return Api()
      .post("/api/work_records", params)
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsReport(params) {
    return Api()
      .get("/api/admin/work_records/report", { params })
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsUserAdmin(params) {
    return Api()
      .get("/api/admin/work_records", { params })
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsRequestUser(params) {
    return Api()
      .get("/api/work_record_requests", { params })
      .catch((err) => errorHandler(err, null));
  },
  // Balance diario de presencia calculado en el back (misma regla que el informe)
  getWorkRecordsBalance(params) {
    return Api()
      .get("/api/work_records/balance", { params })
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsBalanceAdmin(params) {
    return Api()
      .get("/api/admin/work_records/balance", { params })
      .catch((err) => errorHandler(err, null));
  },
  // Nuevos Presence, añadir pause y resume
  getWorkRecordsStatus(params) {
    return Api()
      .get("/api/work_records/status", { params })
      .catch((err) => errorHandler(err, null));
  },
  startWorkRecordsUser(params) {
    return Api()
      .post("/api/work_records/start", params)
      .catch((err) => errorHandler(err, null));
  },
  endWorkRecordsUser(params) {
    return Api()
      .post("/api/work_records/end", params)
      .catch((err) => errorHandler(err, null));
  },
  checkPauseAbsence(pauseReason) {
    return Api().get("/api/work_records/pause-absence-check", { params: { pauseReason } });
  },
  pauseWorkRecordsUser(params) {
    // The caller handles structured validation/conflict errors without duplicate toasts.
    return Api().post("/api/work_records/pause", params);
  },
  resumeWorkRecordsUser(params) {
    return Api()
      .post("/api/work_records/resume", params)
      .catch((err) => errorHandler(err, null));
  },
  // El catch esta en PresenceUserDialog.vue
  postWorkRecordsRequestUser(params) {
    return Api().post("/api/work_record_requests", params);
  },
  batchWorkRecordsRequestUser(params) {
    return Api().post("/api/work_record_requests/batch", params);
  },
  putWorkRecordsRequestUser(id, params) {
    return Api().put("/api/work_record_requests/" + id, params);
  },
  rejectWorkRecordsRequestUser(id, data = {}) {
    return Api()
      .post("/api/admin/work_record_requests/" + id + "/reject", data)
      .catch((err) => errorHandler(err, null));
  },
  approveWorkRecordsRequestUser(id, data = {}) {
    return Api()
      .post("/api/admin/work_record_requests/" + id + "/approve", data)
      .catch((err) => errorHandler(err, null));
  },
  getWorkRecordsRequestAdmin(params) {
    return Api()
      .get("/api/admin/work_record_requests", { params })
      .catch((err) => errorHandler(err, null));
  },
  // Sin .catch: puede devolver errorCode/details (ej. absence_required_via_pause_button con la
  // lista de solicitudes bloqueadas) que el componente necesita leer para mostrar un aviso útil.
  // El catch está en PresenceDialogChanges.vue e InboxItem.vue.
  batchResolveWorkRecordsRequestAdmin(data) {
    return Api().post("/api/admin/work_record_requests/batch-resolve", data);
  },
};
